import { createUrl } from "./createUrl";

export const createPurchaseCompleteXShareLink = ({
  eventId,
  eventTitle,
  twitterHashTag,
}: {
  eventId: string;
  eventTitle: string;
  twitterHashTag: string[];
}): string => {
  const authDomain = window.location.hostname;
  // アカウントのIDに関しては以下のnotionを参照
  // @see https://www.notion.so/balusco/SNS-866f484f8aef433da94debff87338756
  const relatedAccount = "@SPWN_official";
  const shareURL = `https://${authDomain}/events/${eventId}?utm_source=x&utm_medium=social&utm_campaign=got_ticket`;

  const nonEmptyHashTags = twitterHashTag.filter((tag) => 0 < tag.length);
  const hashtagText = nonEmptyHashTags.map((tag) => `#${tag}`).join(" ");
  const shareText = `${eventTitle}のチケットを購入しました！\n${hashtagText} #SPWN\n`;

  return createUrl({
    location: "https://x.com/intent/tweet",
    searchParams: [
      {
        key: "url",
        value: shareURL,
      },
      {
        key: "related",
        value: relatedAccount,
      },
      {
        key: "text",
        value: shareText,
      },
    ],
  });
};
